import { STheme } from 'servisofts-component2';
const inputs = () => {
    return {
        default: {
            LabelStyle: {
                position: "absolute",
                top: -9,
                left: 0,
                fontSize: 12,
                width: "100%",
            },
            View: {
                height: 40,
                borderRadius: 4,
                marginTop: 30,
                borderWidth: 1,
                backgroundColor: "#ffffff10",
                borderColor: STheme.color.primary + 55,
                fontFamily: "Poppins",
            },
            InputText: {
                // fontSize: 16,
                placeholderTextColor: STheme.color.lightGray,
                paddingStart: 8,
                color: STheme.color.text,
                fontFamily: "AlbertSans",
                fontSize: 12,

                backgroundColor: "#ffffff10",
                height: 38,
                borderRadius: 4,
                // backgroundColor: STheme.color.card,
            },
            error: {
                // borderRadius: 16,
                borderWidth: 2,
                borderColor: STheme.color.danger
            }
        }
    }
}
export default inputs;
